// extracted by mini-css-extract-plugin
export default {"notFoundBlock":"Error404_notFoundBlock__duc-4","textBlock":"Error404_textBlock__vTVzH","errorButton":"Error404_errorButton__nYhrc","imageBlock":"Error404_imageBlock__hm+Qp"};